import tokenProvider from "axios-token-interceptor";
import api from ".";
import ls from "../common/ls";

export default function tokenInterceptor() {
    api.interceptors.request.use(tokenProvider({
        getToken: () => ls.token
    }));
}
